import { module } from 'angular';

import { default as surveyViewName, SurveyView } from './survey-view.component.ajs';
import { default as surveyServiceName, SurveyService } from './survey.service';

export default module('contact.agent.helpzone.survey-view', [])
  .component(surveyViewName, new SurveyView())
  .service(surveyServiceName, SurveyService).name;
